<template>
  <div class="row header" v-if='currentUser'>
    <div class="col-4">
      <transition name="fade">
        <a @click.prevent="$props.back()" v-show="$props.showBack" class="back">
          <i class="fas fa-arrow-left"/>
          {{ $t('msoffice.back') }}
        </a>
      </transition>
    </div>
    <div class="col-8">
       <div class="btn-group float-right">
        <a aria-expanded="false" aria-haspopup="false" class="btn-sm user-img-wrapper dropdown-toggle"
           data-toggle="dropdown" href="#">
          <user-image :user='currentUser'/>
          <span class="user-name-wrapper">
        </span>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <li class="dropdown-item full_name">{{ currentUser.full_name }}</li>
          <li><hr class="dropdown-divider"></li>
          <li>
            <router-link :to="{ name: 'home' }" class="dropdown-item" target="_blank">
              <i class="fas fa-external-link-alt"></i>
              {{ $t('msoffice.go_to_relatico') }}
            </router-link>
          </li>
          <li>
            <a class="dropdown-item" @click.prevent="logout">
              <i class="fas fa-sign-out-alt"></i>
              {{ $t('header.logout') }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="unverifiedUser" class="unverified-info">
      <p>
        <strong>{{ $t('verify.info_dashboard') }} </strong> {{ $t('verify.info_dashboard_2') }}
        <br>
        {{ $t('verify.info_part_2') }}
      </p>
    </div>
  </div>
</template>

<script>
import _user_image from '@/components/_user_image'

export default {
  components: {
    'user-image': _user_image
  },
  props: {
    mailbox: {
      type: Object,
      required: true,
    },
    showBack: {
      type: Boolean,
      default: false
    },
    back: {
      type: Function
    }
  },
  computed:{
    office() {
      return window.Office
    },
    platform() {
      return this.office.context.diagnostics.platform || ''
    }
  },
  methods: {
    logout() {
      this.$props.mailbox.getUserIdentityTokenAsync(this.processLogout)
    },
    processLogout() {
      this.$emit('loading')
      this.store.sendMetrics({name: 'outlook_addin_logout', params: this.$route.params, path: this.$route.fullPath})
      this.officeStore.logout().then(() => {
        this.$router.push({name: 'msoffice_home', query: this.$route.query})
      })
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/styles/msoffice.sass"
.fade-enter-active, .fade-leave-active
  transition: opacity .3s
.fade-enter, .fade-leave-to
  opacity: 0
.dropdown-toggle
  font-size: 18px
.dropdown-toggle[aria-expanded="true"]:after
  transform: rotate(-180deg)
.dropdown-toggle:after
  transition: 0.3s
</style>
